import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '@cycle-hangars/routes/Routes';
import { useCycleStore } from '@cycle-hangars/store/store';
import { ErrorMessages } from '@types';
import {
  scrollTop,
  dynamicDateErrorMessage,
  parseZodErrors,
  dateAndTimeRangeSchema,
  dateSchema,
  dynamicDateRangeErrorMessage,
} from '@utils';

import { FormTitle, NavigationButtons, TextInputMolecule } from '@molecules/*';
import { ErrorSummary, InlineErrorMessage } from '@atoms/*';

export const BikeTheft = () => {
  const navigate = useNavigate();
  const { selectedDate, updateSelectedDate } = useCycleStore();
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const [inlineErrorMessage, setInlineErrorMessage] = useState<string>('');
  const title = 'When did you notice the bike theft?';
  const errorPath = 'bikeTheft';

  const resetErrorMessages = () => {
    setErrorMessages([]);
    setInlineErrorMessage('');
  };

  const handleDateInput = (e: FormEvent<HTMLInputElement>) => {
    resetErrorMessages();
    const { name, value } = e.currentTarget;

    const updatedDate = {
      ...selectedDate,
      [name]: value,
    };
    updateSelectedDate(updatedDate);
  };

  const handleClick = () => {
    resetErrorMessages();
    try {
      dateSchema.parse(selectedDate);
      dateAndTimeRangeSchema.parse({
        dayRange: selectedDate.selectedDay,
        monthRange: selectedDate.selectedMonth,
        yearRange: selectedDate.selectedYear,
        minuteRange: 1, //To satisfy time validation
        hourRange: 1, //To satisfy time validation
      });
      navigate(RoutesList.TELL_US_MORE);
      return;
    } catch (error: any) {
      const errors = parseZodErrors(error);
      const paths = errors.map((error) => error.path).sort();
      const dynamicInlineErrorMessage = dynamicDateErrorMessage(
        paths,
      ) as string;
      if (dynamicInlineErrorMessage) {
        setInlineErrorMessage(dynamicInlineErrorMessage);
        setErrorMessages(errors);
      } else {
        const newDateRangeErrorMessage = dynamicDateRangeErrorMessage(
          paths,
          errors,
        );
        if (newDateRangeErrorMessage) {
          setInlineErrorMessage(newDateRangeErrorMessage);
          setErrorMessages(errors);
        }
      }
    }
  };

  const buttonPrevious = {
    onClick: () => navigate(RoutesList.CYCLE_HANGAR_SECURE),
  };

  const buttonNext = {
    onClick: () => {
      handleClick();
      scrollTop();
    },
  };

  return (
    <>
      <div className="-flex flex-col gap-y-2">
        <div className="mb-6">
          <FormTitle text={title} />
          <ErrorSummary messages={errorMessages} />
        </div>
        <InlineErrorMessage
          path={errorPath}
          messages={[{ path: errorPath, message: inlineErrorMessage }]}
        />
        <div className="flex gap-x-4">
          <section className="w-12">
            <TextInputMolecule
              maxLength={2}
              label="Day"
              name="selectedDay"
              errorPath="daySelected"
              value={selectedDate.selectedDay}
              onChange={(e) => handleDateInput(e)}
            />
          </section>
          <section className="w-12">
            <TextInputMolecule
              maxLength={2}
              label="Month"
              name="selectedMonth"
              errorPath="monthSelected"
              value={selectedDate.selectedMonth}
              onChange={(e) => handleDateInput(e)}
            />
          </section>
          <section className="w-16">
            <TextInputMolecule
              maxLength={4}
              label="Year"
              name="selectedYear"
              errorPath="yearSelected"
              value={selectedDate.selectedYear}
              onChange={(e) => handleDateInput(e)}
            />
          </section>
        </div>
        <NavigationButtons
          buttonNext={buttonNext}
          buttonPrevious={buttonPrevious}
        />
      </div>
    </>
  );
};
